import { Toaster } from "@/components/ui/toaster";
import { SonnerToaster } from "@/components/ui";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import ResponsibleAI from "./pages/ResponsibleAI";
import HireAt149 from "./pages/HireAt149";
import HireWithAI from "./pages/HireWithAI";
import FoundersCandidateFinder from "./pages/FoundersCandidateFinder";
import SourcingAssistant from "./pages/SourcingAssistant";
import VendorSourcingModels from "./pages/VendorSourcingModels";
import HireYourselfSubscriptions from "./pages/HireYourselfSubscriptions";
import AutomaticSourcing from "./pages/AutomaticSourcing";
import StartupOffering from "./pages/StartupOffering";
import About from "./pages/About";
import ForTALeaders from "./pages/personas/ForTALeaders";
import Events from "./pages/Events";
import SingleEvent from "./pages/SingleEvent";
import Reports from "./pages/Reports";
import SingleReport from "./pages/SingleReport";
import TalentTalesNewsletter from "./pages/TalentTalesNewsletter";
import NewsletterDetail from "./pages/NewsletterDetail";
import InternalIllustrations from "./pages/InternalIllustrations";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <SonnerToaster />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/sourcing-assistant" element={<SourcingAssistant />} />
            <Route path="/assisted-sourcing-models" element={<VendorSourcingModels />} />
            <Route path="/subscription-model" element={<AutomaticSourcing />} />
            <Route path="/startup-offering" element={<StartupOffering />} />
            <Route path="/hire-yourself-subscriptions" element={<HireYourselfSubscriptions />} />
            {/* Keeping route but removing from nav per request; optional to remove entirely */}
            <Route path="/responsible-ai" element={<ResponsibleAI />} />
            <Route path="/starter-plan" element={<HireAt149 />} />
            <Route path="/hire-with-ai" element={<HireWithAI />} />
            <Route path="/ai-hiring-for-founders" element={<FoundersCandidateFinder />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:eventId" element={<SingleEvent />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/:reportId" element={<SingleReport />} />
            <Route path="/personas/cutshort-for-ta-leaders" element={<ForTALeaders />} />
            <Route path="/talent-tales-newsletter-cutshort" element={<TalentTalesNewsletter />} />
            <Route path="/talent-tales-newsletter-cutshort/:id" element={<NewsletterDetail />} />
            <Route path="/internal-illustrations" element={<InternalIllustrations />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
